<ng-template #boardSeatAddEditModal let-c="close" let-d="dismiss">
    <form #boardSeatAddEditForm="ngForm" [class.submitted]="boardSeatAddEditForm.submitted" (ngSubmit)="submit(boardSeatAddEditForm)" novalidate>
        <div class="modal-header">
            <div class="modal-title"><span class="bold">{{ editMode ? 'Edit' : 'Add new' }}</span> Board Seat</div>
            <button type="button" class="rms-sheet-close" aria-label="Close" (click)="c()">&times;</button>
        </div>
        <div class="modal-body">
            <div class="d-inline-flex w-100 rms-sheet-pair" style="gap: 20px;">
                <div class="form-group w-100">
                    <label for="boardSeatCompany">{{ "GENERICS.COMPANY" | translate }}<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="companyRef" [componentForm]="boardSeatAddEditForm"></rms-required-label>
                    </label>
                    <ng-select [(ngModel)]="boardSeat.company" [items]="companyList"
                               [multiple]="false" [typeahead]="companyTypeahead" [loading]="companySearching" [disabled]="editMode && !boardSeat.active"
                               bindLabel="name" name="boardSeatCompany" id="boardSeatCompany" #companyRef="ngModel" required>
                    </ng-select>
                </div>

                <div class="form-group w-100">
                    <label for="boardSeatPerson">Person<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="personRef" [componentForm]="boardSeatAddEditForm"></rms-required-label>
                    </label>
                    <ng-select [(ngModel)]="boardSeat.person" [items]="people" [multiple]="false" [disabled]="editMode && !boardSeat.active"
                               bindLabel="fullName" name="boardSeatPerson" id="boardSeatPerson" #personRef="ngModel" required>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.fullName }}<span *ngIf="!item.active" class="inactive-label"> (inactive)</span>
                      </ng-template>
                    </ng-select>
                </div>
            </div>

            <div class="date-inputs-container w-100 rms-sheet-pair">
                <div class="form-group date-input-group">
                    <label for="boardSeatStartDate">Start Date<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="boardSeatStartDate" [componentForm]="boardSeatAddEditForm"></rms-required-label>
                    </label>
                    <div class="input-group">
                        <rms-date-picker id="boardSeatStartDate"
                                         name="boardSeatStartDate"
                                         #boardSeatStartDate="ngModel"
                                         [(ngModel)]="startDate"
                                         [isRange]="false"
                                         [disabled]="editMode && !boardSeat.active"
                                         required>
                        </rms-date-picker>
                    </div>
                </div>

                <div *ngIf="editMode && !boardSeat.active" class="form-group date-input-group">
                    <label for="boardSeatEndDate">End Date</label>
                    <div class="input-group">
                         <rms-date-picker id="boardSeatEndDate"
                                        name="boardSeatEndDate"
                                        #boardSeatEndDate="ngModel"
                                        [(ngModel)]="endDate"
                                        [isRange]="false"
                                        [min]="startDate"
                                        [max]="maxEndDate"
                                        [required]="true">
                        </rms-date-picker>
                    </div>
                </div>

                <div class="form-group date-input-group">
                    <label for="boardSeatResignationSentDate">Resignation Sent Date</label>
                    <div class="input-group">
                        <rms-date-picker id="boardSeatResignationSentDate"
                                         name="boardSeatResignationSentDate"
                                         #boardSeatResignationSentDateRef="ngModel"
                                         [(ngModel)]="resignationSentDate"
                                         [disabled]="editMode && !boardSeat.active"
                                         [isRange]="false">
                        </rms-date-picker>
                    </div>
                </div>
            </div>

            <div class="d-inline-flex w-100 rms-sheet-pair" style="gap: 20px;">
                <div class="form-group w-100">
                    <label for="boardSeatRepresenting">Board Seat Representing<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="boardSeatRepresentingRef" [componentForm]="boardSeatAddEditForm"></rms-required-label>
                    </label>
                    <ng-select [(ngModel)]="boardSeat.representing" [items]="boardSeatRepresentingTypes" [disabled]="editMode && !boardSeat.active"
                               name="boardSeatRepresenting" id="boardSeatRepresenting" #boardSeatRepresentingRef="ngModel" required>
                        <ng-template ng-label-tmp let-item="item">{{ BoardSeatRepresentingLabels[item] }}</ng-template>
                        <ng-template ng-option-tmp let-item="item">{{ BoardSeatRepresentingLabels[item] }}</ng-template>
                    </ng-select>
                </div>
                <div class="form-group w-100">
                    <label for="boardSeatRole">Board Role</label>
                    <ng-select id="boardSeatRole" name="boardSeatRole" [disabled]="editMode && !boardSeat.active" [(ngModel)]="boardSeat.boardRole" [items]="restrictionsIntegrationService.boardRoles">
                    </ng-select>
                </div>
            </div>

            <div class="form-group">
                <label for="boardSeatCommittees">Committees</label>
                <textarea id="boardSeatCommittees" name="boardSeatCommittees" class="form-control" [disabled]="editMode && !boardSeat.active" [(ngModel)]="boardSeat.committees" rows="2"></textarea>
            </div>

            <div class="d-inline-flex w-100 rms-sheet-pair" style="gap: 20px;">
                <div class="form-group w-100">
                    <label for="boardSeatContactPerson">Contact Person</label>
                    <input id="boardSeatContactPerson" name="boardSeatContactPerson" class="form-control" [disabled]="editMode && !boardSeat.active" [(ngModel)]="boardSeat.contactPerson" />
                </div>

                <div class="form-group w-100">
                    <label for="boardSeatContactEmail">Contact Email</label>
                    <input id="boardSeatContactEmail" name="boardSeatContactEmail" class="form-control" [disabled]="editMode && !boardSeat.active" [(ngModel)]="boardSeat.contactEmail" />
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="rms-sheet-eze" *ngIf="!environment.production">
              <input id="force-eze-error" name="force-eze-error" type="checkbox" [(ngModel)]="forceEzeError" />
              <label for="force-eze-error">Force Eze Error</label>
            </div>
            <button type="button" class="btn btn-outline-teal" (click)="c()">{{ "GENERICS.CANCEL" | translate }}</button>
            <button type="submit" class="btn btn-teal" [disabled]="boardSeatAddEditForm.invalid">Submit</button>
        </div>
    </form>
</ng-template>
